import React from 'react';

import { useTranslation } from 'react-i18next';

import { DepButton, DepButtonDisplay } from '@pkg/components/deprecated';
import { useAppDispatch, useAppSelector } from '@pkg/hooks';

import { toggleWaitListFTUEPopup } from '@app/store/actions/waitlist';
import { show2faRequirePopup } from '@app/store/slices';

import { Typography } from '../../DesignSystem';

import './FTUEPopup.scss';

const WaitListFTUEPopup = () => {
    const { t } = useTranslation(['waitlist']);
    const ftuePopup = useAppSelector((rootState) => rootState.waitlist.ftuePopup);
    const dispatch = useAppDispatch();

    const onHideFTUEPopup = () => {
        dispatch(toggleWaitListFTUEPopup());
        const twoFactorDelayed = localStorage.getItem('2fa_delayed_popup');
        if (twoFactorDelayed === 'true') {
            setTimeout(() => {
                dispatch(show2faRequirePopup());
            }, 1500);
        }
    };

    if (!ftuePopup) {
        return null;
    }

    return (
        <div className="ftue-popup">
            <div className="ftue-popup__content">
                <Typography
                    variant="h2"
                    type="headline"
                    align="center"
                    size={40}
                    classes={['ftue-popup__content-title']}
                >
                    <span dangerouslySetInnerHTML={{ __html: t('waitlist_ftue_popup_title') }} />
                </Typography>
                <Typography
                    variant="div"
                    type="paragraph"
                    align="center"
                    size={20}
                    classes={['ftue-popup__content-content']}
                >
                    {t('waitlist_ftue_popup_content')}
                </Typography>
                <div className="ftue-popup__content-action">
                    <DepButton size="large" display={DepButtonDisplay.block} onClick={onHideFTUEPopup}>
                        {t('words:next')}
                    </DepButton>
                </div>
            </div>
        </div>
    );
};

export default WaitListFTUEPopup;
